module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-holder"
  }, [_c('div', {
    staticClass: "content-holder"
  }, _vm._l((_vm.model.dynamicUiData), function(component) {
    return _c('div', {
      staticClass: "modal-body"
    }, [(component.displayType == 'datefield') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "date",
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'number') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "number",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'textarea') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "rows": "3",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'textfield') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "text",
        "disabled": !component.iseditable,
        "name": component.propertyName
      },
      domProps: {
        "value": (_vm.form[component.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, component.key, $event.target.value)
        }
      }
    })]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'combobox') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-left"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), _c('span', {
      staticClass: "form-right"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form, component.key, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((component.listvalues), function(listvalue) {
      return _c('option', [_vm._v(_vm._s(listvalue.displayname))])
    }), 0)]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e(), _vm._v(" "), (component.displayType == 'checkbox') ? _c('div', {
      attrs: {
        "id": component.key
      }
    }, [_c('label', {
      staticClass: "form-label"
    }, [_c('span', {
      staticClass: "form-right-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form[component.key]),
        expression: "form[component.key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[component.key]) ? _vm._i(_vm.form[component.key], null) > -1 : (_vm.form[component.key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form[component.key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, component.key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, component.key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, component.key, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "form-left-check"
    }, [_vm._v(_vm._s(component.displayname))]), _vm._v(" "), (component.required === 1) ? _c('span', {
      staticClass: "mandatoryMark"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "validationMsg"
    }, [_vm._v(_vm._s(_vm.errorMsg[component.key]))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "validationMsg"
  }, [_vm._v(_vm._s(_vm.validationMessage))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    class: {
      button: true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideMetadataPopup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("\n                        cancel\n                    ")]), _vm._v(" "), _c('button', {
    class: {
      button: true
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v("\n                        submit\n                    ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Fields marked with "), _c('span', {
    staticClass: "mandatoryMarkText"
  }, [_vm._v("*")]), _vm._v(" are mandatory")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f78ffa2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropzone/DynamicUiForm.vue
// module id = 168
// module chunks = 1